import { onViewAllMenuClickedMutator } from '../actions/onViewAllMenuClickedMutator';
import { onChangeMoveToMailboxTypeMutator } from '../actions/onChangeMoveToMailbox';
import { lazyGetArchiveFolders, lazyGetSharedFoldersForSpecificRoot } from 'owa-folders';
import type { MailboxInfo } from 'owa-client-types';

const VIEW_ALL_MOVE_TO_MENU = 'VIEW_ALL_MOVE_TO_MENU';

// gets called when user clicks on view all menu item for any mailbox
export const onViewAllMenuClicked = async (mailboxInfo: MailboxInfo): Promise<void> => {
    onViewAllMenuClickedMutator(mailboxInfo);
    /* eslint-disable-next-line owa-custom-rules/allow-one-mutator-per-sync-scope -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, add a justification or fix the error.
     *	> It is not allowed to have multiple mutator calls within the same sync scope, combine the mutators into one to avoid unnecessary re-renders. */
    onChangeMoveToMailboxTypeMutator(mailboxInfo.type);
    switch (mailboxInfo.type) {
        case 'ArchiveMailbox':
            (await lazyGetArchiveFolders.import())(
                mailboxInfo,
                VIEW_ALL_MOVE_TO_MENU /* Archive mailbox folders loading source */
            );
            break;
        case 'SharedMailbox':
            (await lazyGetSharedFoldersForSpecificRoot.import())(
                mailboxInfo,
                'moveToControl' /* actionSource */
            );
            break;
        default:
            return;
    }
};
